import { render, staticRenderFns } from "./RiskItemToolbar.vue?vue&type=template&id=d21d027a&scoped=true&"
import script from "./RiskItemToolbar.vue?vue&type=script&lang=js&"
export * from "./RiskItemToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RiskItemToolbar.vue?vue&type=style&index=0&id=d21d027a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21d027a",
  null
  
)

export default component.exports